import { useState } from 'react';
import { doc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../lib/firebase';
import toast from 'react-hot-toast';
import { useContestStatus } from './useContestStatus';
import { getIpInfo, recordVote } from '../services/ipService';

const VOTE_COOLDOWN = 12 * 60 * 60 * 1000; // 12 hours

export const useVoting = (treeId?: string) => {
  const [isVoting, setIsVoting] = useState(false);
  const [hasVoted, setHasVoted] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState<number | null>(null);
  const { isEnded } = useContestStatus();

  const handleVote = async () => {
    if (!treeId || isVoting || hasVoted || isEnded) return;

    setIsVoting(true);
    try {
      // Get IP info first
      const ipInfo = await getIpInfo();
      
      // Update tree votes
      const treeRef = doc(db, 'trees', treeId);
      await updateDoc(treeRef, {
        votes: increment(1)
      });

      // Record vote with IP info
      await recordVote(treeId, ipInfo);

      // Update local storage
      const votedTrees = JSON.parse(localStorage.getItem('votedTrees') || '[]');
      votedTrees.push({
        treeId,
        timestamp: Date.now(),
        ip: ipInfo.ip
      });
      localStorage.setItem('votedTrees', JSON.stringify(votedTrees));
      
      setHasVoted(true);
      setTimeRemaining(VOTE_COOLDOWN);
      toast.success('¡Gracias por tu voto!');
    } catch (error) {
      console.error('Error voting:', error);
      toast.error('Error al registrar el voto');
    } finally {
      setIsVoting(false);
    }
  };

  return {
    isVoting,
    hasVoted,
    timeRemaining,
    handleVote
  };
};